<div class="environment-info-container {{ cssClass }}">
  @if (environmentInfoText) {
    <span [innerHtml]="environmentInfoText"></span>
  } @else {
    <span>Miljö: {{ environmentName }}</span>
  }
</div>
